import React from "react";
import { Chip, Box, Typography } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";

export default function TagBox({ tags, isDisplay = false, onRemove }) {
  const handleDelete = (uuid) => (event) => {
    event.stopPropagation();
    if (onRemove) {
      onRemove(uuid);
    }
  };

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
      {tags.length > 0 ? (
        tags.map((tag) => (
          <Chip
            key={tag.uuid}
            label={tag.name}
            onDelete={!isDisplay ? handleDelete(tag.uuid) : undefined}
            deleteIcon={<CancelIcon fontSize="small" />}
            size="small"
            sx={{
              height: 28,
              backgroundColor: "background.paper",
              border: "1px solid",
              borderColor: "divider",
              "& .MuiChip-label": {
                px: 1,
              },
            }}
          />
        ))
      ) : (
        <Typography variant="body2" color="text.secondary"></Typography>
      )}
    </Box>
  );
}
